export const trimEmail = (email?: string) => {
  const length = email?.length ?? 0;

  if (length > 12) {
    return `${email?.substring(0, 8)}...${email?.substring(length - 8, length)}`;
  }

  return email ?? "";
};
